/**
 * @generated SignedSource<<0fd2b23ed3045697c84c64ea00f2fc93>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "formDetailId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FormDetailDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteFormDetailTPayload",
        "kind": "LinkedField",
        "name": "deleteFormDetailTByFormDetailId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FormDetailT",
            "kind": "LinkedField",
            "name": "formDetailT",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FormDetailDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteFormDetailTPayload",
        "kind": "LinkedField",
        "name": "deleteFormDetailTByFormDetailId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FormDetailT",
            "kind": "LinkedField",
            "name": "formDetailT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nodeId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ba3ad5f367b5866153a1b2dbbb228457",
    "id": null,
    "metadata": {},
    "name": "FormDetailDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation FormDetailDeleteMutation(\n  $input: DeleteFormDetailTByFormDetailIdInput!\n) {\n  deleteFormDetailTByFormDetailId(input: $input) {\n    formDetailT {\n      formDetailId\n      nodeId\n    }\n  }\n}\n"
  }
};
})();

node.hash = "c7cc28c025e6ee52b6546a960ad26326";

module.exports = node;
